import {useTranslation} from 'react-i18next';
import {PriceItem} from '@chekin/core';
import {usePaymentSettings} from 'hooks';
import {CounterSize} from 'components/common/Counter';

import {Main, Price, PerLabel, PricePerLabel, StyledCounter} from './styled';

type PriceCounterProps = {
  price: number;
  value: number;
  unitType?: PriceItem['unit_type'];
  onChange?: (value: number) => void;
};

const getPricePerKey = (unitType: PriceItem['unit_type']) =>
  `upselling_add_to_card_form.price.${unitType?.toLocaleLowerCase() || 'per_unit'}`;

const formatPrice = (currencySymbol: string, price: number) =>
  `${currencySymbol}${price.toFixed(2)}`;

export const PriceCounter = ({price, value, unitType, onChange}: PriceCounterProps) => {
  const {t} = useTranslation();
  const {currencySymbol} = usePaymentSettings();

  const mainLabel = formatPrice(currencySymbol, price);
  const secondaryLabel = `/${t(getPricePerKey(unitType))}`;

  return (
    <Main>
      <PricePerLabel>
        <Price>{mainLabel}</Price>
        <PerLabel>{secondaryLabel}</PerLabel>
      </PricePerLabel>
      <StyledCounter value={value} size={CounterSize.S} onChange={onChange} />
    </Main>
  );
};
